import { render, staticRenderFns } from "./InactiveGoalBlock.vue?vue&type=template&id=6797420f&scoped=true&lang=pug"
import script from "./InactiveGoalBlock.vue?vue&type=script&lang=js"
export * from "./InactiveGoalBlock.vue?vue&type=script&lang=js"
import style0 from "./InactiveGoalBlock.vue?vue&type=style&index=0&id=6797420f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797420f",
  null
  
)

export default component.exports